import React from 'react';

/**
 * Returns a function that forces the calling component to re-render when called.
 */
export const useForcedRerender = (): (() => void) => {
  const [, setTick] = React.useReducer((tick: number) => tick + 1, 0);
  return setTick as () => void;
};
